// extracted by mini-css-extract-plugin
export default {"title":"CurrentCoverage_title__San0o"};